import { render, staticRenderFns } from "./BaixarDocumentoAta.vue?vue&type=template&id=67ed0b10&scoped=true"
import script from "./BaixarDocumentoAta.vue?vue&type=script&lang=js"
export * from "./BaixarDocumentoAta.vue?vue&type=script&lang=js"
import style0 from "./BaixarDocumentoAta.vue?vue&type=style&index=0&id=67ed0b10&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed0b10",
  null
  
)

export default component.exports